import { cn } from "../ui/cn";

type Props = {
	className?: string;
	height?: string;
	maxWidth?: string;
};

export const XpressLogo = ({ height }: Props) => {
	return (
		<img
			alt="Logo for XPress for Business"
			src="/images/svg/xpress_logo.svg"
			className={`${height} w-auto`}
		/>
	);
};

export const XpressForBusinessLogo = ({
	className = '',
	height = '',
	maxWidth = 'max-w-[383px]',
}: Props) => {
	return (
		<img
			alt="Logo for XPress for Business"
			src="/images/svg/xpress_for_business_logo.svg"
			className={cn('w-full', className, maxWidth, height)}
			width={383}
			height={64}
		/>
	);
};

export const XpressForBusinessLogoWhite = ({ className }: Props) => {
	return (
		<img
			alt="Logo for XPress for Business"
			src="/images/svg/xpress_for_business_logo_white.svg"
			className={className}
			width={213}
			height={32}
		/>
	);
};
